// const baseURL = "http://localhost:5000"; 

const baseURL = "https://crm.sbsgroups.co.in:8080";


export default baseURL;